import { AppState } from '../../../../../state/createStore';
import { bindActionCreators, Dispatch } from 'redux';
import { openModal } from '../../../../../state/session/session.actions';
import RestaurantTakeoutDetails from './RestaurantTakeoutDetails';
import { connect } from 'react-redux';

function mapStateToProps(state: AppState, ownProps: any) {
  return {
    ...ownProps,
    isLocationPicked: state.session.isLocationPicked,
    formErrorsVisiblity: state.addressForm.errorsVisibility,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      openModal,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantTakeoutDetails);
